import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from "../util/api";

export const fetchSettingsFeatures = createAsyncThunk("settingsFeatures/fetchSettingsFeatures", async () => {
    const response = await api.get(`v2/api/settings/features/`).catch(err => {
        throw new Error(err.response.data.message[0]?.text);
    });
    return response.data;
});

//updatetopicimage
export const updateImageFeature = createAsyncThunk("settingsFeatures/updateImageFeature", async ({id, formData}) => {
    const response = await api
        .post(`v2/api/settings/features/${id}/upload`, formData, {
            headers: {"Content-Type": "multipart/form-data"},
        })
        .catch(err => {
            throw new Error(err.response.data.message[0]?.text);
        });
    return response.data;
});

//editTopic
export const updateFeature = createAsyncThunk("settingsFeatures/updateFeature", async ({values, topicId}) => {
    const response = await api.put(`v2/api/settings/features/${topicId}`, values).catch(err => {
        throw new Error(err.response.data.message[0]?.text);
    });
    return response.data;
});

//editTopic
export const updateTranslation = createAsyncThunk("settingsFeatures/updateTranslation", async ({values, topicId}) => {
    const response = await api.put(`v2/api/settings/features/${topicId}/translation`, values).catch(err => {
        throw new Error(err.response.data.message[0]?.text);
    });
    return response.data;
});

const initialState = {
    features: [],
    status: {
        type: "idle",
        error: null,
    },
};

const settingsFeaturesSlice = createSlice({
    name: "settingsFeatures",
    initialState,
    reducers: {
        setInitialState: state => initialState,
    },
    extraReducers: {
        [fetchSettingsFeatures.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [fetchSettingsFeatures.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.features = action.payload.data;
        },
        [fetchSettingsFeatures.rejected]: (state, action) => {
            state.status.type = "failed";
            state.status.error = action.error.message;
        },
        [updateImageFeature.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [updateImageFeature.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.types = action.payload.data;
        },
        [updateImageFeature.rejected]: (state, action) => {
            state.status.type = "failed";
            state.status.error = action.error.message;
        },
        [updateFeature.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [updateFeature.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.features = action.payload.data;
        },
        [updateFeature.rejected]: (state, action) => {
            state.status.type = "failed";
            state.status.error = action.error.message;
        },
        [updateImageFeature.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [updateImageFeature.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.features = action.payload.data;
        },
        [updateImageFeature.rejected]: (state, action) => {
            state.status.type = "failed";
            state.status.error = action.error.message;
        },
        [updateTranslation.pending]: (state, action) => {
            state.status.type = "loading";
        },
        [updateTranslation.fulfilled]: (state, action) => {
            state.status.type = "succeeded";
            state.features = action.payload.data;
        },
        [updateTranslation.rejected]: (state, action) => {
            state.status.type = "failed";
            state.status.error = action.error.message;
        },
    },
});

export const {setInitialState} = settingsFeaturesSlice.actions;
export default settingsFeaturesSlice.reducer;
